import { render, staticRenderFns } from "./wf-formattable-text-area-display.vue?vue&type=template&id=00f61929&scoped=true&"
import script from "./wf-formattable-text-area-display.vue?vue&type=script&lang=ts&"
export * from "./wf-formattable-text-area-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-formattable-text-area-display.vue?vue&type=style&index=0&id=00f61929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f61929",
  null
  
)

export default component.exports